import PropTypes from 'prop-types';
import React from 'react';
import { StatusPill } from 'components/v3';

// v3 StatusPill color sets for the Learning Hub domain states.
const VARIANTS = {
  published: {
    color: '#1F9D57',
    background: 'rgba(52, 210, 123, 0.13)',
    border: 'rgba(52, 210, 123, 0.34)',
  },
  draft: {
    color: '#64748B',
    background: 'rgba(100, 116, 139, 0.13)',
    border: 'rgba(100, 116, 139, 0.34)',
  },
  discover: {
    color: '#8B5CF6',
    background: 'rgba(139, 92, 246, 0.13)',
    border: 'rgba(139, 92, 246, 0.34)',
  },
  howto: {
    color: '#2C6FD6',
    background: 'rgba(44, 111, 214, 0.13)',
    border: 'rgba(44, 111, 214, 0.34)',
  },
  new: {
    color: '#FA4616',
    background: 'rgba(250, 70, 22, 0.13)',
    border: 'rgba(250, 70, 22, 0.34)',
  },
  featured: {
    color: '#FA4616',
    background: 'rgba(250, 70, 22, 0.13)',
    border: 'rgba(250, 70, 22, 0.34)',
  },
};

export const MODE_LABELS = {
  discover: 'Ideas & Tips',
  howto: 'How To Do It',
};

const VariantPill = ({ variant, label, dot }) => {
  const colors = VARIANTS[variant] || VARIANTS.draft;
  return <StatusPill label={label} dot={dot} {...colors} />;
};

VariantPill.propTypes = {
  variant: PropTypes.oneOf(Object.keys(VARIANTS)).isRequired,
  label: PropTypes.string.isRequired,
  dot: PropTypes.bool,
};

VariantPill.defaultProps = {
  dot: true,
};

export default VariantPill;
